<template>
  <roe-error-message :field="design.service_requirement_profit_sharing">
    <v-select
      v-model.number="design.$model.service_requirement_profit_sharing"
      :options="[
        { code: 0, label: 'No' },
        {
          code: 1,
          label: 'Yes, SAME service requirement as Employee Contributions'
        },
        {
          code: 2,
          label:
            'Yes, DIFFERENT service requirement than Employee Contributions. Same for all employees'
        },
        {
          code: 3,
          label:
            'Yes, DIFFERENT service requirement than Employee Contributions. Varies by type of employee'
        }
      ]"
      :reduce="label => label.code"
      @input="onChange()"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeEmployerOtherServiceRequirementSelect",
  mixins: [ResetDesignAttributesMixin],
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    onChange() {
      this.resetAttributes(this.design, "service_requirement_profit_sharing");
      if (this.design.$model.service_requirement_profit_sharing === 1) {
        this.design.$model.service_requirement_profit_sharing_measurement_number = this.design.$model.service_requirement_measurement_number;
      }
    }
  }
};
</script>
